import React, { useMemo } from "react";

import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import StatsAPI from "@/src/api/StatsAPI";

import { bandwidthQuery } from "./usage.queries";
import { buildBandwidthTimeline, getBandwidthSeriesList } from "./usage.utils";
import ExportCsvButton from "../charts/ExportCsvButton";
import TimelineQueryCard from "../charts/TimelineQueryCard";

import type { JSX } from "react";

import type { AppState } from "@/src/reducers";

import type { UsagePeriodProps } from "./usage.types";

function BandwidthTimelineCard({ period }: UsagePeriodProps): JSX.Element {
  const { t } = useTranslation("editor-analytics");
  const organizationOptions = useSelector(
    (state: AppState) =>
      state.fetchReducer.orga_config.data?.organization_options,
  );
  const seriesList = useMemo(
    () => getBandwidthSeriesList(organizationOptions, (key) => t(key)),
    [organizationOptions, t],
  );
  const fetchCsv = async (): Promise<BlobPart> =>
    StatsAPI.getBandwidth({
      startDate: period.startDate,
      endDate: period.endDate,
      isExport: true,
    });

  return (
    <TimelineQueryCard
      buildTimeline={buildBandwidthTimeline}
      endDate={period.endDate}
      query={bandwidthQuery(period)}
      seriesList={seriesList}
      startDate={period.startDate}
      title={t("usage.charts.bandwidth")}
      unit="bytes"
      extraActions={
        <ExportCsvButton fetchCsv={fetchCsv} fileName="bandwidth.csv" />
      }
    />
  );
}

export default BandwidthTimelineCard;
